import React from "react";
import "./ThreadInfo.css";

type ThreadInfoProps = {
  avatar?: string;
  label: string;
  className?: string;
};

export const ThreadInfo = ({
  avatar,
  label,
  className = "",
}: ThreadInfoProps) => {
  return (
    <>
      {label === "" ? null : (
        <div className={`agent-chat-thread-info ${className}`}>
          {avatar && (
            <div className="agent-chat-thread-info-avatar">
              <img src={avatar} alt="Thread Avatar" />
            </div>
          )}
          <div className="agent-chat-thread-info-name">{label}</div>
        </div>
      )}
    </>
  );
};
